module.exports = __webpack_public_path__ + "img/3dForm7.049e13f4.svg";